import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const InputFileUpload = ({ btnTxt, color, handleFileUpload, icon }) => {
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={icon}
      sx={{
        backgroundColor: '#475569',
        color: '#ffffff',
        textTransform: 'none',
        borderRadius: '6px',
        boxShadow: 'none',

        '&:hover': {
          backgroundColor: '#334155',
          boxShadow: 'none',
        },
      }}
    >
      {btnTxt}
      <VisuallyHiddenInput
        type="file"
        onChange={(event) => handleFileUpload(event.target.files)}
        multiple
      />
    </Button>
  );
};

InputFileUpload.propTypes = {
  btnTxt: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
};

export default InputFileUpload;